import Vue from 'vue';
import { mapGetters } from 'vuex';
import AbstractSortableGrid from './AbstractSortableGrid.vue';
import Project from 'src/api/project';
import DataUtils from 'src/utils/data';
import { debounce } from 'lodash';
import DeleteDataFileModal from './DeleteDataFileModal.vue';
import { BfButton, BfTooltipWrapper } from 'components/Butterfly';
import Dropdown from 'components/Butterfly/Dropdown/Dropdown.vue';
import DropdownItem from 'components/Butterfly/Dropdown/DropdownItem.vue';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    components: { AbstractSortableGrid, BfButton, BfTooltipWrapper, DeleteDataFileModal, Dropdown, DropdownItem },
    props: {},
    data() {
        return {
            data: {},
            gettingData: false,
            pageSize: 3,
            pageNumber: 1,
            sortBy: '',
            sortOptions: [
                { key: '-created', label: 'Recently Added' },
                { key: 'file_name', label: 'Alphanumeric' },
                { key: '-records', label: '# of Records' }
            ],
            getDataFilesBebounced: debounce((pageNumber, sortBy) => {
                return Project.getDataFiles(pageNumber, this.projectId, sortBy, this.pageSize)
                    .then((response) => {
                    // Only apply the payload if the requested page number
                    // is still matching what was set on the widget. It's
                    // possible that the user already navigated to a
                    // different page in the meantime.
                    if (this.pageNumber === pageNumber) {
                        this.pageNumber = response?.pageNumber ?? pageNumber;
                        this.data = response;
                    }
                }).finally(() => { this.gettingData = false; });
            }, 500),
            dataImportToDelete: null,
        };
    },
    computed: {
        ...mapGetters(['currentProject', 'currentUser', 'subscription']),
        rowLimitExceeded() {
            return this.subscription?.projectRowLimit && this.currentProject?.data_units > this.subscription?.projectRowLimit;
        },
        dataFiles() {
            return this.data.results;
        },
        projectId() {
            return this.$route.params.projectId;
        },
        integrationProvider() {
            return this.currentProject?.integration?.type;
        },
        integrationEnabled() {
            return this.currentProject.integration && this.currentProject.integration.enabled;
        },
        isDataProcessing() {
            // analysis.statuses
            // inprogress: processing, updating, created, pending
            // done: Finished, error
            return this.currentProject.processing ||
                !!this.currentProject.analyses.find(a => !['FINISHED', 'ERROR'].includes(a.status.toUpperCase()));
        }
    },
    mounted() {
        this.sortBy = this.sortOptions[0].key;
        this.getDataFiles(1, this.sortBy, true);
    },
    methods: {
        number: FormatUtils.number,
        formatDate: DataUtils.formatDate,
        getDataFiles(pageNumber, sortBy, force = false, background = false) {
            if (force || (pageNumber !== this.pageNumber)) {
                this.gettingData = !background;
                this.pageNumber = pageNumber;
                return this.getDataFilesBebounced(pageNumber, sortBy);
            }
        },
        addData() {
            if (this.integrationEnabled) {
                this.$router.push({ name: 'add-bucket-data', params: { projectId: this.projectId } });
            }
        },
        async deleteDataImport(autoUpdateOnDelete) {
            if (this.dataImportToDelete === null) {
                return;
            }
            const dataFileId = this.dataImportToDelete.id;
            await Project.deleteDataFile(dataFileId, autoUpdateOnDelete);
            this.$analytics.track.project.deleteData(false, this.currentProject.id);
            this.dataImportToDelete = null;
            await this.getDataFiles(1, this.sortBy, true);
        },
        // Delete a file in the Error state
        deleteErroredFile(dataFile) {
            if (dataFile.status === 'ERROR') {
                this.dataImportToDelete = dataFile;
            }
            this.$analytics.track.project.deleteData(true, this.currentProject.id);
        },
        tooltipTextProjectDataButton() {
            if (!this.integrationEnabled) {
                return "Re-enable the integration to add new data";
            }
            else if (this.isDataProcessing) {
                return "New data cannot be added while processing is happening";
            }
            else {
                return "";
            }
        }
    }
});
